var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M2.1 3.33h11.69V1.97H2.09v1.36zm0 10.7h2.18v-8.6H2.09v8.6zm4.27 0h7.42v-8.6H6.37v8.6zM1.7 16C.75 16 0 15.3 0 14.42V1.58C0 .7.75 0 1.7 0h12.6c.95 0 1.7.7 1.7 1.58v12.84c0 .89-.75 1.58-1.7 1.58H1.7z", "fill-rule": "evenodd" } }] }, name: "design", theme: "outlined" };
export {
  e as default
};
